import { isValidUuidV7 } from './is-valid-uuid-v7.js';
import { uuidArraySchema } from './uuid-array-schema.js';
/** Empty array passes; each present element must be a UUID (optional multi-select filters), and a stored set passes its own `maxItems` and message. */
export const optionalUuidArray = (invalidMessage, options) => uuidArraySchema(invalidMessage, isValidUuidV7, options);
//# sourceMappingURL=optional-uuid-array.js.map